import React from 'react'
import style from '../../components/admin/exam/ExamResult.module.css'
import { Link, useParams } from 'react-router-dom';
import TPTExamInstruction from './TPTExamInstruction';

const StartTPT = ({
  exam,
  examStarted,
  timeLeft,
  startExam,
  submitExam,
  questions,
  answers,
  currentQuestionIndex,
  setCurrentQuestionIndex,
  selectedSubject,
  setSelectedSubject,
  handleOptionChange,
  handleMarkForReview,
  read,
  setRead,
  studentExam,
  availableSubjects,
  filteredQuestions,
  handleSubjectChange,
  handleNavigateToQuestion,
  getQuestionNumber,
  starting,
  processing
}) => {
  const { email, examId } = useParams();
  const formatTime = (timeInSeconds) => {
    const hours = Math.floor(timeInSeconds / 3600);
    const minutes = Math.floor((timeInSeconds % 3600) / 60);
    const seconds = timeInSeconds % 60;
    return `${hours}:${minutes < 10 ? "0" + minutes : minutes}:${seconds < 10 ? "0" + seconds : seconds}`;
  };
  return (
    <div>
      <div className="start-exam">
        {!examStarted ? (
          <div className="container mt-5">
            <div className={`${style.instruction} mt-2`}>
              <h6>Instructions : </h6>
              <TPTExamInstruction />
            </div>
            <div className="d-flex mt-4 mb-1">
              <input type="checkbox" onClick={() => setRead(!read)} /> <span className="ml-2">I have read the above instructions.</span>
            </div>
            {
              !studentExam?.attempts || studentExam?.attempts < exam?.attempts ?
                <button disabled={starting} onClick={startExam} className="start-btn btn btn-primary mt-3">
                  {starting?'Starting ...':'Start Exam'}
                </button>
                :
                <button disabled className="start-btn btn btn-info mt-3">
                  Attempted
                </button>
            }
            <p className="mt-2"><Link to={`/student/${email}`}>Back</Link></p>
          </div>
        ) : (
          <div className="container-fluid">
            <div className="mt-2 p-3" style={{ backgroundColor: "#8000D5" }}>
              <h5 className="text-center text-white">Monarch Institute</h5>
              <h5 className="text-center text-white">NEET - Online Exam</h5>
              <h5 className="text-center text-white">Exam Name : {exam.examName}</h5>
            </div>
            <div className="row">
              <div className="col-lg-3 col-sm-12">
                <p className="mt-3 ml-2">
                  <span>
                    <b>Time Left :</b> {formatTime(timeLeft)}
                  </span>
                </p>
              </div>
              <div className="mt-2 col-lg-9 col-sm-12" style={{ justifySelf: 'center' }}>
                {availableSubjects.map((subject) => (
                  <button
                    key={subject}
                    onClick={() => handleSubjectChange(subject)}
                    className={`btn btn-sm m-1 ${subject === selectedSubject ? "btn-success" : "btn-secondary"}`}
                  >
                    {subject}
                  </button>
                ))}
              </div>
            </div>
            <div className="row mt-3">
              <div className="col-md-3">
                <h6>Note : </h6>
                <button className="btn btn-sm btn-success m-1">Answered</button>
                <button className="btn btn-sm btn-secondary m-1">Unanswered</button>
                <button className="btn btn-sm btn-warning m-1">Review</button><br />
                {filteredQuestions.map((question, index) => (
                  <button
                    key={question._id}
                    style={{ paddingLeft: '6px', paddingRight: '6px', paddingTop: '5px', paddingBottom: '5px' }}
                    className={`btn btn-sm m-1 btn-${answers[question._id]?.status === "attempted" && answers[question._id]?.review === false
                      ? "success"
                      : answers[question._id]?.review === true
                        ? "warning"
                        : "secondary"
                      }`}
                    onClick={() => handleNavigateToQuestion(index)}
                  >
                    {index+1}
                  </button>
                ))}
              </div>

              <div className="col-md-9">
                {filteredQuestions.length > 0 && (
                  <div className="question">
                    <span className="fw-bold fs-5">
                      Q {currentQuestionIndex+1}
                    </span>
                    <div
                      className="question-preview"
                      dangerouslySetInnerHTML={{
                        __html: filteredQuestions[currentQuestionIndex].question,
                      }}
                    />
                    {filteredQuestions[currentQuestionIndex].options &&
                      filteredQuestions[currentQuestionIndex].options.length > 0 && (
                        <div>
                          {filteredQuestions[currentQuestionIndex].options.map((option, idx) => (
                            <div key={idx}>
                              <label className="mr-2">({idx + 1})</label>
                              <input
                                className="mr-2"
                                type="radio"
                                id={`option-${currentQuestionIndex}-${idx}`}
                                name={`question-${filteredQuestions[currentQuestionIndex]._id}`}
                                value={option}
                                checked={answers[filteredQuestions[currentQuestionIndex]._id]?.answer === option}
                                onChange={() => handleOptionChange(currentQuestionIndex, option, idx)}
                              />
                              <label
                                htmlFor={`option-${currentQuestionIndex}-${idx}`}
                                dangerouslySetInnerHTML={{
                                  __html: option,
                                }}
                              ></label>
                            </div>
                          ))}
                        </div>
                      )}
                    <button
                      onClick={() => handleMarkForReview(filteredQuestions[currentQuestionIndex]._id)}
                      className="btn btn-info mt-2 btn-sm"
                    >
                      {answers[filteredQuestions[currentQuestionIndex]._id].review
                        ? "Unmark for review"
                        : "Mark for Review"}
                    </button>
                  </div>
                )}
                <div className="mt-3">
                  <button
                    onClick={() => setCurrentQuestionIndex(currentQuestionIndex - 1)}
                    disabled={currentQuestionIndex === 0}
                    className="btn btn-secondary btn-sm"
                  >
                    Previous
                  </button>
                  <button
                    onClick={() => setCurrentQuestionIndex(currentQuestionIndex + 1)}
                    disabled={currentQuestionIndex === filteredQuestions.length - 1}
                    className="btn btn-secondary ml-2 btn-sm"
                  >
                    Next
                  </button>
                </div>
                <button disabled={processing} className="mt-5 mb-3 btn btn-success btn-sm" onClick={submitExam}>
                {processing ? 'Processing ...' : 'Submit Exam'}
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  )
}

export default StartTPT
